import React, { useEffect, useState } from 'react';
import { Col, Row, Button, Switch, Tabs, Modal } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import axios from 'axios';
import Swal from "sweetalert2";
import notification from '../../utils/notification';
import Tables from '../../components/Table/Tables';
import { ReadCookie } from '../../utils/readCookie';
import { TabTitle } from '../../utils/GeneralFunction';
import Loader from "react-loader-spinner";
import { BASEURL } from '../../constant/config';
import moment from 'moment';



const { TabPane } = Tabs;
const InventoryRoutine = () => {
    TabTitle("Inventory Routine")
    const token = ReadCookie("token");

    const [switchLoading, setSwitchLoading] = useState(false);
    const [startLoading, setStartLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [routineLog, setRoutineLog] = useState([]);
    const [statusLog, setStatusLog] = useState([]);
    const [statusLogDetail, setStatusLogDetail] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);


    useEffect(() => {
        getRoutineLog();
        getRoutineStatus();
    }, []);

    const getRoutineLog = () => {
        axios({
            method: "POST",
            url: `${BASEURL}getAll/getInventoryRoutine`,
            headers: {
                Accept: "application/json",
                Authorization: "Bearer " + token,
            }
        }).then(function (response) {
            setRoutineLog(response?.data?.data)
        })
    }


    const getRoutineStatus = () => {
        axios({
            method: "POST",
            url: `${BASEURL}getAll/getInventoryRoutineLogs`,
            headers: {
                Accept: "application/json",
                Authorization: "Bearer " + token,
            }
        }).then(function (response) {
            setStatusLog(response?.data?.data);
           
            setLoading(false)
        })
    }


    const column = [
        {
            title: '#',
            dataIndex: 'sno',
            key: 'sno',
            width: 40,
            render: (text, record, index) => {
                return text
            },
        },
        {
            title: "Login ID",
            dataIndex: "login_id",
            key: "login_id",
        },
        {
            title: "User Name",
            dataIndex: "user_name",
            key: "user_name",
        },
        {
            title: "Date & Time",
            dataIndex: "date_time",
            key: "date_time",
            render: (text, record) => {
                return moment(text).format("MM-DD-YYYY HH:mm")
            }
        },
        {
            title: "Routine Status",
            dataIndex: "is_routine_status",
            key: "is_routine_status",
            render: (text, record) => {
                return text === true ? "ON" : "OFF"

            }
        },

    ];


    const columnStatus = [
        {
            title: '#',
            dataIndex: '',
            key: '',
            width: 40,
            render: (text, record, index) => {
                return index + 1
            },
        },
        {
            title: "Log Status",
            dataIndex: "log_status",
            key: "log_status",

        },
        {
            title: "Start Time",
            dataIndex: "start_time",
            key: "start_time",
            render: (text, record) => {
                return moment(text).format("MM-DD-YYYY HH:mm")
            }
        },
        {
            title: "End Time",
            dataIndex: "end_time",
            key: "end_time",
            render: (text, record) => {
                return record.log_status === "COMPLETED" ? moment(text).format("MM-DD-YYYY HH:mm") : "-"
            }
        },
        {
            title: "Action",
            dataIndex: "",
            key: "",
            render: (text, record) => {
                return record.log_status === "COMPLETED" ? <EyeOutlined style={{ fontSize: 16, cursor: "pointer" }} onClick={() => {
                    setModalOpen(true);
                    setStatusLogDetail(record.detail);
                }} /> : '-'
            }
        },



    ];

    const columnStatusDetail = [
        {
            title: '#',
            dataIndex: '',
            key: '',
            width: 40,
            render: (text, record, index) => {
                return index + 1
            },
        },
        {
            title: "SKU",
            dataIndex: "sku",
            key: "sku",

        },
        {
            title: "UPC",
            dataIndex: "upc",
            key: "upc",
        },
        {
            title: "Old Shopify QTY",
            dataIndex: "shopify_quantity",
            key: "shopify_quantity",
        },
        {
            title: "ERP QTY",
            dataIndex: "erp_quantity",
            key: "erp_quantity",
        },



    ];

    const startHandler = () => {
        setStartLoading(true)
        axios({
            method: "GET",
            url: `https://regency.fasreports.com/erptonedeafshopifyInventory/products`,
            headers: {
                Accept: "application/json",
                Authorization: "Bearer " + token,
            },
            // data: { is_routine_status: event ? true : false }
        }).then(function (response) {

            // handle success
            if (response.status == 202) {
                setStartLoading(false);
                notification('success', 'Inventory Routine', 'Inventory Routine Started Successfully')
                getRoutineLog()
                getRoutineStatus()
            }
        })
            .catch(function (error) {
                setStartLoading(false);
                // handle error
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Inventory Routine Failed",
                });

            })
            .finally(function () {
                // always executed
            });
    }

    const switchHandler = (event) => {
        setSwitchLoading(true)
        axios({
            method: "POST",
            url: `${BASEURL}create/inventoryRoutine`,
            headers: {
                Accept: "application/json",
                Authorization: "Bearer " + token,
            },
            data: { is_routine_status: event ? true : false }
        }).then(function (response) {

            // handle success
            if (response.status == 200) {
                setSwitchLoading(false);
                notification('success', 'Inventory Routine', 'Inventory Routine Created Successfully')
                getRoutineLog()

            }
        })
            .catch(function (error) {
                setSwitchLoading(false);
                // handle error
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Inventory Routine Failed",
                });

            })
            .finally(function () {
                // always executed
            });
    }

    let status = routineLog && routineLog[0]?.is_routine_status || false;
    let inventory_status = statusLog && statusLog[0]?.log_status === 'COMPLETED'  ? true : false;


    const handleTab = (key) => {
        if (key === "2") {
            setLoading(true)
            getRoutineStatus()
        }

    };


    const handleOk = () => {
        setModalOpen(false);
    }




    return (
        <>
            <Row gutter={[18, 12]}>
                {
                    switchLoading ? (
                        <div>
                            <div className="loaderDiv">
                                <Loader type="Grid" color="#212121" height={40} width={40} />
                                <div>
                                    <p style={{ fontSize: 26 }}>Please Wait Until the current Routine is completed.</p>
                                </div>
                            </div>
                        </div>
                    ) : null
                }
                <Col className="gutter-row" span={6}>
                    <div>
                        <Button
                            style={{ background: (inventory_status && status )&& "#3d4b58", color: (inventory_status && status) ? "#ffff" : "grey" }}
                            disabled={(!inventory_status && !status) ? true : false}
                            size='large'
                            loading={startLoading}
                            onClick={() => startHandler()}
                        >
                            START
                        </Button>
                    </div>
                </Col>
                <Col className="gutter-row" span={6}>
                    <div style={{ display: "flex", gap: 20 }}>
                        <span>Status :</span>
                        <Switch
                            checkedChildren="ON"
                            unCheckedChildren="OFF"
                            checked={status}
                            onChange={switchHandler} />
                    </div>
                </Col>

            </Row >
            <div style={{ paddingTop: "200px" }}>
                <Tabs
                    type="card"
                    size="small"
                    defaultActiveKey="1"
                    centered
                    onChange={(key) => handleTab(key)}
                >
                    <TabPane tab="Status Logs" key="1">
                        <Tables
                            type="company"
                            scrollX={"50rem"}
                            scroll={360}
                            perPage={15}
                            source={routineLog}
                            col={column}
                            paginate
                        />
                    </TabPane>

                    <TabPane tab="Inventory Logs" key="2">
                        <div className="tabs">
                            <Tables
                                type="company"
                                scrollX={"50rem"}
                                scroll={360}
                                perPage={15}
                                source={statusLog}
                                col={columnStatus}
                                paginate
                                load={loading}
                            />
                        </div>
                        {modalOpen && <Modal width={"90%"}
                            title={
                                "Inventory Logs Detail"
                            }
                            visible={true}
                            onOk={handleOk}
                            okText={"Ok"}
                            onCancel={() => setModalOpen(false)}
                        // confirmLoading={confirmLoading}
                        >
                            <Tables
                                type="company"
                                scrollX={"50rem"}
                                scroll={360}
                                perPage={15}
                                source={statusLogDetail}
                                col={columnStatusDetail}
                                paginate
                                load={loading}
                            />
                        </Modal>}
                    </TabPane>

                </Tabs>

            </div>
        </>
    )
};
export default InventoryRoutine;



